@if (loaded) {
  <div class="tab-container overview-container">
    <mat-card>
      <div
        #mainProjectLoadingIndicator="dtOverlayProgress"
        [dtOverlayProgress]
        dtOverlayProgressColor="accent"
        [dtOverlayProgressForceRelative]="false"
      >
      </div>
      <mat-card-header>
        <mat-card-title>
          <span i18n>Bearbeitungsrecht</span>
          @if (editTokenData[0].state === 'valid') {
            @if (editTokenData[0].holder.id === userMember.id) {
              <div i18n class="edit-right-status edit">Belegt von Dir</div>
            } @else {
              <div i18n class="edit-right-status locked"
                >Belegt von&NonBreakingSpace;<dt-team-member-name [member]="editTokenData[0].holder"></dt-team-member-name>
              </div>
            }
          } @else {
            <div i18n class="edit-right-status free">Verfügbar</div>
          }
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (tokenExpiryText) {
          <div class="token-expiry-text">
            {{ tokenExpiryText }}
          </div>
        }
      </mat-card-content>
      <mat-card-actions>
        @if (editTokenData[0].state === 'valid' && editTokenData[0].holder.id === userMember.id) {
          <button mat-stroked-button color="accent" (click)="returnEditToken()">
            <span i18n>Bearbeitungsrecht abgeben</span>
          </button>
        } @else {
          <span [matTooltip]="editRightStatusTooltip">
            <button mat-raised-button color="accent" (click)="takeEditToken()" [disabled]="!editTokenData[1].canTake">
              <span i18n>Bearbeitungsrecht nehmen</span>
            </button>
          </span>
        }
      </mat-card-actions>
    </mat-card>
    <mat-card class="tasks-card no-content-padding">
      <mat-card-header>
        <mat-card-title i18n>Deine Aufgaben</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <dt-team-task-list [tasks]="userTasks" [team]="team" [teamCalc]="teamCalc" [showFilter]="false"></dt-team-task-list>
      </mat-card-content>
    </mat-card>
    @if (team.accessLog) {
      <mat-card class="no-content-padding">
        <mat-card-header>
          <mat-card-title i18n>Bearbeitungsrecht-Logbuch</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <dt-team-access-log [teamId]="team.id"></dt-team-access-log>
        </mat-card-content>
      </mat-card>
    }
    <mat-card class="no-content-padding" [class.hidden-card]="!unreadComments.hasUnreadComments">
      <mat-card-header>
        <mat-card-title i18n>Ungelesene Kommentare</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <dt-team-unread-comments #unreadComments [teamId]="team.id"></dt-team-unread-comments>
      </mat-card-content>
    </mat-card>
    <mat-card class="whiteboard-card no-content-padding" #whiteboardProgress="dtOverlayProgress" [dtOverlayProgress]>
      <mat-card-header>
        <mat-card-title>
          <span i18n>Whiteboard</span>
          @if (doesUserHaveEditorRights) {
            <button mat-icon-button color="accent" (click)="toggleWhiteboardEdit()" [disabled]="whiteboardProgress.visible$ | async">
              <mat-icon>{{ editingWhiteboard ? 'save' : 'edit' }}</mat-icon>
            </button>
          }
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <dt-rich-text-editor [(text)]="team.whiteboard" [readonly]="!editingWhiteboard || (whiteboardProgress.visible$ | async)">
        </dt-rich-text-editor>
      </mat-card-content>
    </mat-card>
    <mat-card class="forum-card no-content-padding">
      <mat-card-header>
        <mat-card-title i18n>Forum</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <dt-team-comments [object]="{ uuid: 'whiteboard' }"></dt-team-comments>
      </mat-card-content>
    </mat-card>
  </div>
}

@if (!loaded) {
  <mat-progress-bar></mat-progress-bar>
}
